/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminTicketScanResponse } from './AdminTicketScanResponse';
import {
    AdminTicketScanResponseFromJSON,
    AdminTicketScanResponseFromJSONTyped,
    AdminTicketScanResponseToJSON,
} from './AdminTicketScanResponse';

/**
 * 
 * @export
 * @interface AdminTicketScan
 */
export interface AdminTicketScan {
    /**
     * 
     * @type {string}
     * @memberof AdminTicketScan
     */
    customerId: string;
    /**
     * 
     * @type {string}
     * @memberof AdminTicketScan
     */
    deviceLookupId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminTicketScan
     */
    deviceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminTicketScan
     */
    playerLookupId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminTicketScan
     */
    playerId?: string | null;
    /**
     * 
     * @type {AdminTicketScanResponse}
     * @memberof AdminTicketScan
     */
    scanResponse: AdminTicketScanResponse;
}

/**
 * Check if a given object implements the AdminTicketScan interface.
 */
export function instanceOfAdminTicketScan(value: object): value is AdminTicketScan {
    if (!('customerId' in value) || value['customerId'] === undefined) return false;
    if (!('scanResponse' in value) || value['scanResponse'] === undefined) return false;
    return true;
}

export function AdminTicketScanFromJSON(json: any): AdminTicketScan {
    return AdminTicketScanFromJSONTyped(json, false);
}

export function AdminTicketScanFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminTicketScan {
    if (json == null) {
        return json;
    }
    return {
        
        'customerId': json['customerId'],
        'deviceLookupId': json['deviceLookupId'] == null ? undefined : json['deviceLookupId'],
        'deviceId': json['deviceId'] == null ? undefined : json['deviceId'],
        'playerLookupId': json['playerLookupId'] == null ? undefined : json['playerLookupId'],
        'playerId': json['playerId'] == null ? undefined : json['playerId'],
        'scanResponse': AdminTicketScanResponseFromJSON(json['scanResponse']),
    };
}

export function AdminTicketScanToJSON(value?: AdminTicketScan | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'customerId': value['customerId'],
        'deviceLookupId': value['deviceLookupId'],
        'deviceId': value['deviceId'],
        'playerLookupId': value['playerLookupId'],
        'playerId': value['playerId'],
        'scanResponse': AdminTicketScanResponseToJSON(value['scanResponse']),
    };
}

